import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=eff1fbfa&scoped=true"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"
import style0 from "./Checkbox.css?vue&type=style&index=0&id=eff1fbfa&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff1fbfa",
  null
  
)

export default component.exports